import { useEffect, useState } from "react";
import axios from "axios";
import { BACKEND_URL } from "../lib/api";

// A club's live room data (ticker, screens…), refreshed every minute so admin changes reach open tables.
export const useClubLive = (slug) => {
  const [live, setLive] = useState(null);
  useEffect(() => {
    if (!slug) { setLive(null); return; }
    const load = () => axios.get(`${BACKEND_URL}/api/clubs/${slug}`).then((r) => setLive(r.data)).catch(() => {});
    load();
    const id = setInterval(load, 60000);
    return () => clearInterval(id);
  }, [slug]);
  return live;
};
